import React, { Component } from 'react';
import strings from '../locales/';
/* Components */
import LoadingModal from '../common/loadingModal';

const ModalUpdate = props => (
  <div
    data-close="ok"
    onClick={props.handleModal}
    className={props.modal ? `container-modal` : `container-modal hide`}
  >
    <section className="module-title modal-title">
      <h2>{props.language.account.createDriver.importOne}</h2>
      <p id="file-error" className="error none">
        {props.language.account.others.incorrectFormat}
      </p>
      {((props.status === 500 || props.status === 400)) && (
        <p className="error">{props.language.error[`cod${props.datos.error.code}`]} </p>
      )}
      <a>
        <i data-close="ok" onClick={props.handleModal} className="fas fa-times-circle" />
      </a>
      {props.status == null && (
        <p className="normal-text ">
          {props.language.account.modalDriver.normalText}{' '}
          <strong onClick={props.handleDownload} className="active-link">
            {props.language.account.modalDriver.buttonDownload}
          </strong>
        </p>
      )}
    </section>
    {props.status == null && (
      <div className={`box-modal max500`}>
        <section id="modal-update" className="base-form">
          <div className="box-form top">
            <div className="container-file">
              <label htmlFor="file" className="custom-file-upload">
                {props.language.account.modalDriver.examine}
              </label>
              <span id="file-1" />
              <input
                required
                onChange={props.handleUploadValue}
                id="file"
                name="file"
                type="file"
              />
            </div>
          </div>
        </section>
      </div>
    )}
    {props.status == null && (
      <div className={'box-form islabel top center modal-button-box '}>
        <div>
          {props.loading ? (
            <div className="spiner">
              <i className="fas fa-spinner fa-spin" /> {props.language.account.others.loading}
            </div>
          ) : (
            <input
              onClick={props.handleUpload}
              id="btn-upload"
              type="button"
              value={props.language.account.modalDriver.buttonUpdateFile}
            />
          )}
        </div>
      </div>
    )}
    {props.status === 200 && (
      <div className={`box-modal max500`}>
        <section className="feed-back green">
          <div>
            <i className="fas fa-check-circle" />
          </div>
          <div>
            <p>{props.language.account.modalDriver.feedBackDriverUpdateOne}</p>
          </div>
        </section>
      </div>
    )}
    {((props.status === 500 || props.status === 400))  && (
      <div className={`box-modal max500`}>
        {props.datos.error.params.length > 0 && (
          <section className="module-table top">
            <table className="fixed">
              <thead>
                <tr>
                  <th className="th70">{props.language.account.table.row}</th>
                  <th className="th50">{props.language.account.modalDriver.type}</th>
                  <th>{props.language.account.modalDriver.detail}</th>
                </tr>
              </thead>
              <tbody>
                {props.datos.error.params.map((item, i) => (
                  <tr key={`cod-${i}`}>
                    <td className="red center">{item.rowNum}</td>
                    <td className="borde center red">{item.messageType}</td>
                    <td className="borde">{strings.error[`cod${item.messageCode}`]}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </section>
        )}
        <section className="module-title top bottom">
          {props.datos.error.params.length > 0 && (
            <p className="error"> {props.language.account.modalDriver.feedBackDriverUpdateTwo}</p>
          )}
          {props.datos.error.params.length > 0 && (
            <p className="warning">
              {props.language.account.modalDriver.feedBackDriverUpdateThree}
            </p>
          )}
        </section>
      </div>
    )}
  </div>
);

export default ModalUpdate;



// WEBPACK FOOTER //
// ./source/client/components/account_driver/modalUpdate.jsx